module.exports = __webpack_public_path__ + "static/media/logo-cuid.bf24b327.png";